import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';

import './assets/fonts/fonts.css';
import './styles/tokens.css';
import './styles/app.css';
import './print/print.css';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
